import React, { useEffect } from 'react';

export const Terms: React.FC<{acceptTerms: () => Promise<void>}> = ({ acceptTerms }) => {
    useEffect(() => {
        acceptTerms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // we no longer show a terms page, we just accept implicitly
    return null;
};
